import React, { useEffect, useState } from 'react';
import { Avatar, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { PhoneCall } from 'react-feather';
import { useDraftStyles } from './styles';

const MS_PER_SECOND = 1000;
const SECONDS_PER_MINUTE = 60;
const TIME_PART_LENGTH = 2;
const WAVE_BARS = 5;
const PHONE_ICON_SIZE = 22;

const formatElapsed = (seconds: number) =>
    [Math.floor(seconds / SECONDS_PER_MINUTE), seconds % SECONDS_PER_MINUTE]
        .map((part) => String(part).padStart(TIME_PART_LENGTH, '0'))
        .join(':');

/**
 * Shown while an AI call runs: elapsed time since it started.
 */
export const AICallProgress = () => {
    const classes = useDraftStyles();
    const { t } = useTranslation();
    const [elapsedSeconds, setElapsedSeconds] = useState(0);

    useEffect(() => {
        const startedAt = Date.now();
        const timer = window.setInterval(
            () =>
                setElapsedSeconds(
                    Math.floor((Date.now() - startedAt) / MS_PER_SECOND)
                ),
            MS_PER_SECOND
        );
        return () => window.clearInterval(timer);
    }, []);

    return (
        <div aria-live="polite" className={classes.callProgress} role="status">
            <Avatar className={classes.callPulse}>
                <PhoneCall aria-hidden="true" size={PHONE_ICON_SIZE} />
            </Avatar>
            <span>
                <Typography variant="subtitle2">
                    {t('Assistant.AICallInProgress')}
                </Typography>
                <Typography color="textSecondary" variant="caption">
                    {t('Assistant.AICallDurationHint')}
                </Typography>
                <span aria-hidden="true" className={classes.callWave}>
                    {Array.from({ length: WAVE_BARS }, (_, bar) => (
                        <span className={classes.callWaveBar} key={bar} />
                    ))}
                </span>
            </span>
            <Typography color="primary" variant="h6">
                {formatElapsed(elapsedSeconds)}
            </Typography>
        </div>
    );
};
